import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';

const PaginationWidget = ({
  page,
  totalPages,
  onPageChange,
  itemsPerPage,
  onItemsPerPageChange,
  totalItems,
  onRefresh,
  itemsPerPageOptions = [1, 5, 10, 15],
  showSelectAll = false,
  onSelectAll,
  selectedCount = 0,
  totalSelectable = 0,
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 0, marginBottom: 35, gap: 16, padding: '12px 18px', background: '#f4f8fb', borderRadius: 12, border: '1.5px solid #e0e7ef', boxShadow: '0 2px 8px #0001' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <button
          onClick={onRefresh}
          title="Refrescar"
          style={{ background: '#fff', border: '1.5px solid #1da1f2', color: '#1da1f2', borderRadius: 8, padding: '8px 14px', fontWeight: 600, fontSize: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
        >
          <FontAwesomeIcon icon={faSyncAlt} />
        </button>
        
        {/* Botón Seleccionar todos */}
        {showSelectAll && totalSelectable > 0 && (
          <>
            <button
              onClick={onSelectAll}
              style={{
                background: selectedCount === totalSelectable ? '#e74c3c' : '#1da1f2',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '8px 16px',
                fontWeight: 600,
                fontSize: 14,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                transition: 'all 0.2s ease'
              }}
              title={selectedCount === totalSelectable ? 'Deseleccionar todos' : 'Seleccionar todos'}
            >
              {selectedCount === totalSelectable ? (
                <>
                  <span style={{ fontSize: 12 }}>✓</span>
                  Deseleccionar
                </>
              ) : (
                <>
                  <span style={{ fontSize: 12 }}>☐</span>
                  Seleccionar todos ({totalSelectable})
                </>
              )}
            </button>
            {selectedCount > 0 && (
              <span style={{ 
                background: '#e8f5e8', 
                color: '#155724', 
                padding: '4px 8px', 
                borderRadius: 6, 
                fontSize: 12, 
                fontWeight: 600 
              }}>
                {selectedCount} seleccionado{selectedCount !== 1 ? 's' : ''}
              </span>
            )}
          </>
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {page > 1 && (
          <button
            onClick={() => onPageChange(page - 1)}
            style={{ padding: '8px 18px', borderRadius: 6, border: '1.5px solid #1da1f2', background: '#fff', color: '#1da1f2', fontWeight: 600, fontSize: 16, cursor: 'pointer', marginRight: 8 }}
          >
            Anterior
          </button>
        )}
        <span style={{ fontWeight: 600, fontSize: 16 }}>
          Página {page} de {totalPages}
        </span>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          style={{ padding: '8px 18px', borderRadius: 6, border: '1.5px solid #1da1f2', background: page >= totalPages ? '#eee' : '#fff', color: page >= totalPages ? '#bbb' : '#1da1f2', fontWeight: 600, fontSize: 16, cursor: page >= totalPages ? 'not-allowed' : 'pointer', marginLeft: 8 }}
        >
          Siguiente
        </button>
      </div>
      <div>
        <label style={{ fontWeight: 600, fontSize: 16, marginRight: 8 }}>Items por página:</label>
        <select
          value={itemsPerPage}
          onChange={e => onItemsPerPageChange(Number(e.target.value))}
          style={{ padding: '8px 12px', borderRadius: 6, border: '1.5px solid #1da1f2', fontWeight: 600, fontSize: 16 }}
        >
          {itemsPerPageOptions.map(num => (
            <option key={num} value={num}>{num}</option>
          ))}
        </select>
      </div>
      <div style={{ fontWeight: 600, fontSize: 16 }}>
        Total: {totalItems} productos
      </div>
    </div>
  );
};

export default PaginationWidget; 